import clsx from "clsx";

export interface ButtonProps {
  text: string;
  variant?:
    | "primary"
    | "primaryLight"
    | "secondary"
    | "ternary"
    | "selected"
    | "deselected";
  size?: "sm" | "base" | "md" | "lg";
  width?: string;
  rounded?: "none" | "sm" | "base" | "md" | "lg" | "full";
  action?: () => void;
  className?: string;
  icon?: React.ReactNode;
}

export function Button(props: ButtonProps) {
  const { text, width, variant, size, action, className, rounded, icon } =
    props;

  const variants = {
    primary:
      "font-medium text-sm text-primary-white bg-primary-blue rounded-full hover:bg-[#3B3938] transition-colors duration-200 ease-out",
    primaryLight:
      "font-medium text-sm text-primary-blue border border-primary-blue rounded-full",
    secondary:
      "font-medium text-sm text-primary-blue bg-primary-white rounded-full hover:text-[#3B3938] transition-colors duration-200 ease-out",
    ternary: "text-[15px] font-medium underline",
    selected:
      "w-full py-1.5 px-3 gap-2.5 font-medium text-sm text-primary-blue border border-primary-blue rounded-full",
    deselected:
      "w-full py-1.5 px-3 gap-2.5 font-medium text-sm text-primary-blue",
  };

  const corners = {
    none: "rounded-none",
    sm: "rounded-sm",
    base: "rounded-base",
    md: "rounded-md",
    lg: "rounded-lg",
    full: "rounded-full",
  };

  const sizes = {
    none: "p-0",
    sm: "px-4 py-2",
    base: "px-4 py-2.5",
    md: "px-8 py-4",
    lg: "px-12 py-6",
  };

  return (
    <button
      className={clsx(
        "inline-flex items-center justify-center",
        variant && variants[variant],
        size && sizes[size],
        rounded && corners[rounded],
        width,
        className
      )}
      onClick={action}
    >
      {text}
      {icon && <span className="ml-2">{icon}</span>}
    </button>
  );
}

export default Button;
